import React from 'react';

interface LocationCellProps {
  location: string | undefined | null;
  getLocationColor: (loc: string) => string | null;
  getShortName?: (loc: string) => string;
  borderWidth?: string;
}

export function LocationCell({ location, getLocationColor, getShortName, borderWidth = '3px' }: LocationCellProps) {
  if (!location) return <span>—</span>;
  const color = getLocationColor(location);
  const display = getShortName ? getShortName(location) : location;
  return (
    <span
      className={`text-[10px] font-medium ${color ? 'px-1.5 py-0.5 rounded' : ''}`}
      style={color ? {
        backgroundColor: `${color}30`,
        borderLeft: `${borderWidth} solid ${color}`
      } : undefined}
      title={location}
    >
      {display}
    </span>
  );
}
